module.exports = __webpack_public_path__ + "static/visa-8486189aadc4809ebd8edfe89452e223.png";